<template>
    <swiper class="buttons colors" :loop="true" :currentPage="currentPage"
            @slider-move="slideMove"
            @slide-touch-end="onSlideTouchEnd"
            @slide-change-page="onSlideChangePage">
        <div class="infinity-swipe-item" v-for="(color, index) in colors">
          <button :class="{active: currentPage==index+1}" @click="onButtonClick(index+1)">
            <span class="circle" :style="circleStyle(color)">
            {{ color.label }}
            </span>
          </button>
          <div class="price" v-show="color.price>0">+{{ color.price | currency }}</div>
        </div>
    </swiper>
</template>

<script>
  import InfinitySwipe from '../../../../../InfinitySwipe.vue'
  export default {
    name: 'colors',
    components: {
      swiper: InfinitySwipe,
    },
    data(){
      return {
        touch_time: 0
      }
    },
    props: ['selectedColor', 'colors'],
    computed: {
      currentPage(){
        if (this.colors.indexOf(this.selectedColor) === -1) return 1;
        return this.colors.indexOf(this.selectedColor) + 1;
        // for (var i = 0; i < this.colors.length; i++){
        //   if (this.colors[i].id == this.selectedColor.id){
        //     return i+1;
        //   }
        // }
//        return this.colors.indexOf(this.selectedColor) + 1;
      },
    },
    methods: {
      circleStyle: function(color){
        return {
          backgroundColor: color.color,
          border: (color.color.toUpperCase() == '#FFFFFF') ? '1px solid black' : 'none',
          width: '38px',
          height: '38px',
        }
      },
      setPage: function (page) {
        this.$emit('setColor', this.colors[page - 1]);
      },
      onButtonClick: function (page) {
        if (this.touch_time < 300) {
          this.onSlideChangePage(page);
        }
      },
      onSlideTouchEnd: function(page, time){
        this.touch_time = time;
        this.onSlideChangePage(page);
      },
      onSlideChangePage: function (page) {
        this.setPage(page);
      },
      slideMove: function (translate, delta) {
        let item_width = 50;
        let page = this.currentPage;
        if (delta < 0) {
          page = Math.floor(translate / item_width) * -1 + 1;
        } else {
          page = Math.floor(translate / item_width) * -1;
        }
        if (page <= 0) page = 1;
        if (page > this.colors.length) page = this.colors.length + 1;
        if (this.colors[page - 1] !== undefined) {
          this.setPage(page);
        }
      },
    }
  }
</script>


<style scoped>
  #product-menu .colors {
    background-color: #ffffff;
  }
  .colors button {
      border-bottom: 1px solid gray;
      background-color: #fff;
      color: #000;
      width: 50px;
      height: 50px;
      margin: 0;
      padding: 0;
      border-radius: 0;
  }
  .colors button .circle {
      display: inline-block;
      -webkit-border-radius:;
      -moz-border-radius:;
      border-radius: 20px;
      width: 40px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      overflow: hidden;
  }
  .infinity-swipe-item {
      width: 50px;
  }
  .infinity-swipe-item > button.active {
      border-left: 1px solid gray;
      border-right: 1px solid gray;
  }
  .price{
    position: absolute;
    bottom: 1px;
    background-color: rgb(235,52,35);
    color: white;
    border-radius: 6px;
    padding: 2px 4px;
    margin-left: 4px;

    white-space: nowrap;
    font-size: 10px;
  }
</style>
